/**
 * Base64 for values that travel through URLs.
 *
 * Encoding emits the url-safe alphabet without padding (RFC 4648 §5): our encoded values are handed
 * to upstreams that paste them into a query parameter verbatim, where a `+` would come back as a
 * space and `/` is at the mercy of whatever builds the link.
 *
 * Decoding accepts both alphabets and tolerates missing padding, since a value returning to us may
 * have been re-encoded anywhere along the way. Throws on input that is not base64 at all (`atob`),
 * so callers decoding untrusted data must catch.
 */
export function utf8ToBase64(value: string): string {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function base64ToUtf8(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}
